// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Divider,
    Fab,
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getCustomer, getSales, getDesigner } from '../../../../api/helper';

interface AddProps {
    contact?: any | null
}

export default function Add({ contact = null }: AddProps) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valCustomer, setValCustomer] = useState<any>(null)
    const [listCustomer, setListCustomer] = useState<any[]>([])

    const [valSales, setValSales] = useState<any>(null)
    const [listSales, setListSales] = useState<any[]>([])

    const [valDesigner, setValDesigner] = useState<any>(null)
    const [listDesigner, setListDesigner] = useState<any[]>([])

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdcust_id: any,
        sdsalesman_id: any,
        nomor_po: any,
        tgl: any,
        tgl_close: any,
        tgl_kirim: any,
        keterangan: any,
        designer_id: any,
    }

    const defaultValues = {
        keterangan: '',
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
        tgl_close: new Date(new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).setDate(new Date().getDate() + 7)).toISOString().substring(0, 16),
        tgl_kirim: new Date(new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).setDate(new Date().getDate() + 7)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.quotation, cabang, token);
            if (response.length > 0 && response.length == 1) {
                setValDoctag(response[0])
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchCustomer = async () => {
            const response = await getCustomer(token);
            setListCustomer(response);
        };
        const fetchSales = async () => {
            const response = await getSales(token);
            setListSales(response);
        };
        const fetchDesigner = async () => {
            const response = await getDesigner(cabang, token);
            setListDesigner(response);
        };
        fetchDoctag();
        fetchCustomer();
        fetchSales();
        fetchDesigner();
    }, [])

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue)
    }
    const handleChangeAutocompleteSales = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdsalesman_id', newValue ? newValue.id : null)
        setValSales(newValue)
    }
    const handleChangeAutocompleteCustomer = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdcust_id', newValue ? newValue.id : null)
        setValCustomer(newValue)
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/quotation/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/sales/quotation/detail/' + response.data.data)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleChangeAutocompleteDesigner = (event: SyntheticEvent, newValue: any | null) => {
        setValue('designer_id', newValue ? newValue.id : null)
        setValDesigner(newValue)
    }


    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Quotation
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valSales}
                                        options={listSales}
                                        id='sales'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteSales}
                                        getOptionLabel={(option: any) => option?.nama || ""}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Sales'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    window.open('/sales/master-salesman/add', '_blank')
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valCustomer}
                                        options={listCustomer}
                                        id='customer'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteCustomer}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Customer'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    window.open('/sales/master-customer/add', '_blank')
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDesigner}
                                        options={listDesigner}
                                        id='designer_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDesigner}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Designer'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_close'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal Close'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_close)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_close && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal Close harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal Kirim'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_kirim)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal Kirim harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
